<app-spinner></app-spinner>
<app-header-navbar></app-header-navbar>
<app-navbar></app-navbar>
<div class="content">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
